import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Card,
  Button,
  Row,
  Col,
  Divider,
  Tag,
  Drawer,
  Typography,
  List,
  Modal,
  Calendar,
  Flex,
} from "antd";

import {
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  MinusOutlined,
  CalendarOutlined,
  CloseOutlined,
  InfoCircleOutlined,
  CheckCircleFilled,
  ClockCircleOutlined,
  UserOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import LeadGuestDetails from "./LeadGuestDetails";
import HotelBannerImg from "../assets/images/hotelImage.jpg";
import EnjoyActivities from "../assets/images/enjoyActivities.jpg";
import ExCountryImg from "../assets/images/ex-country-1.jpg";
import ExCountryImgTwo from "../assets/images/ex-country-2.jpg";
import HotelCategory from "../assets/images/hotelCategory.jpg";
import HotelCategoryTwo from "../assets/images/hotelCategoryTwo.jpg";

import { Popover, Collapse } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axiosInstance from "../api/axiosInstance";
import { useParams } from "react-router-dom";

const addons = [
  {
    id: 1,
    title:
      "Sunrise Desert Safari with Sand Boarding & Camel Riding at Red Dunes",
    adultPrice: 199,
    childPrice: 149,
    image: HotelBannerImg,
  },
  {
    id: 2,
    title:
      "Sunrise Desert Safari with Quad Biking, Sand Boarding & Photo with Falcon",
    adultPrice: 349,
    childPrice: 299,
    image: EnjoyActivities,
  },
  {
    id: 3,
    title: "Sunrise Desert Safari with 30 Minutes Camel Riding & Sand Boarding",
    adultPrice: 349,
    childPrice: 299,
    image: ExCountryImg,
  },
  {
    id: 4,
    title: "Sunrise Desert Safari with Dune Buggy at Red Dunes Lahbab Desert",
    adultPrice: 599,
    childPrice: 499,
    image: ExCountryImgTwo,
  },
  {
    id: 5,
    title: "Sunrise Desert Safari with Dune Buggy at Red Dunes Lahbab Desert",
    adultPrice: 599,
    childPrice: 499,
    image: HotelCategory,
  },
  {
    id: 6,
    title: "Sunrise Desert Safari with Dune Buggy at Red Dunes Lahbab Desert",
    adultPrice: 599,
    childPrice: 499,
    image: HotelCategoryTwo,
  },
];

const timeSlots = [
  { time: "7:00 AM", status: "available" },
  { time: "7:30 AM", status: "sold" },
  { time: "8:00 AM", status: "limited" },
  { time: "8:30 AM", status: "available" },
  { time: "9:00 AM", status: "available" },
  { time: "9:30 AM", status: "available" },
  { time: "10:00 AM", status: "available" },
  { time: "10:30 AM", status: "available" },
  { time: "11:00 AM", status: "available" },
  { time: "11:30 AM", status: "limited" },
  { time: "12:00 PM", status: "available" },
];

const BookingPage = ({
  open,
  onClose,
  initialDate,
  priceMap,
  productDetailId,
}) => {
  const [openPopover, setOpenPopover] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  const [showAllSlots, setShowAllSlots] = useState(false);
  const [selectedTransfer, setSelectedTransfer] = useState(
    "Private Transportation",
  );
  const transferOptions = [
    {
      title: "Without Transportation",
      description: "Transportation services are not part of this package.",
      price: 0,
    },
    {
      title: "Sharing Transportation",
      description: "Transportation services are not part of this package.",
      price: 0,
    },
    {
      title: "Private Transportation",
      description: "Transportation provided throughout your journey.",
      price: 4876.9,
    },
  ];
  const visibleSlots = showAllSlots ? timeSlots : timeSlots.slice(0, 8);
  const [selectedDate, setSelectedDate] = useState(
    initialDate ? dayjs(initialDate) : dayjs(),
  );

  const PrevArrow = ({ className, style, onClick }) => (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#163c96",
        borderRadius: "50%",
        width: 48,
        height: 48,
        left: "-24px",
        zIndex: 1000,
      }}
      onClick={onClick}
    >
      <LeftOutlined style={{ color: "#fff", fontSize: 18 }} />
    </div>
  );

  const NextArrow = ({ className, style, onClick }) => (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#163c96",
        borderRadius: "50%",
        width: 48,
        height: 48,
        right: "-24px",
        zIndex: 1000,
      }}
      onClick={onClick}
    >
      <RightOutlined style={{ color: "#fff", fontSize: 18 }} />
    </div>
  );

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // const isSelected = selectedDate?.isSame(current, "day");
  const [calendarMonth, setCalendarMonth] = useState(
    selectedDate.startOf("month"),
  );

  const goPrevMonth = () => {
    setCalendarMonth((prev) => prev.subtract(1, "month"));
  };

  const goNextMonth = () => {
    setCalendarMonth((prev) => prev.add(1, "month"));
  };

  const cellRender = (current, info) => {
    if (info.type !== "date") return info.originNode;

    const key = current.format("YYYY-MM-DD");
    const price = priceMap[key];

    const isSelected = selectedDate.isSame(current, "day");

    return (
      <div className={`calendar-cell ${isSelected ? "active" : ""}`}>
        <div>{current.date()}</div>

        {price && <div className="price">AED {(price / 1000).toFixed(1)}K</div>}
      </div>
    );
  };

  const selectedRef = useRef(null);
  const stripRef = useRef(null);
  const [calendarOpen, setCalendarOpen] = useState(false);

  const getPrice = (date) => {
    const key = date.format("YYYY-MM-DD");

    // Use actual price if available
    if (priceMap[key]) {
      return priceMap[key];
    }

    // Temporary fallback for dates not in priceMap
    return 22000;
  };

  const dates = useMemo(() => {
    const startDate = selectedDate.subtract(2, "day");

    return Array.from({ length: 5 }, (_, index) => {
      const date = startDate.add(index, "day");

      return {
        date: date.format("YYYY-MM-DD"),
        price: getPrice(date),
      };
    });
  }, [selectedDate]);

  const [adult, setAdult] = useState(1);
  const [child, setChild] = useState(0);
  const [infant, setInfant] = useState(0);

  const [openModal, setOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packages, setPackages] = useState([]);
  const [packagesLoading, setPackagesLoading] = useState(false);
  const [packagesError, setPackagesError] = useState("");
  const [selectedAddon, setSelectedAddon] = useState(null);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        setPackagesLoading(true);
        setPackagesError("");

        if (!productDetailId) {
          setPackages([]);
          return;
        }

        const res = await axiosInstance.get(
          `/packages?filters[product_detail][id][$eq]=${productDetailId}&populate=*`,
        );

        setPackages(res.data?.data || []);
      } catch (error) {
        console.error("🔥 Packages API Error:", error);
        console.error("🔥 Error response:", error?.response?.data);

        setPackagesError(
          error?.response?.data?.error?.message || "Unable to load packages.",
        );

        setPackages([]);
      } finally {
        setPackagesLoading(false);
      }
    };

    if (productDetailId) {
      fetchPackages();
    }
  }, [productDetailId]);

  const { Text, Paragraph, Title } = Typography;
  useEffect(() => {
    setVisible(true);
  }, []);

  const [step, setStep] = useState(1); // 1 = package, 2 = lead guest
  // ✅ animation state
  const [animate, setAnimate] = useState(false);

  const location = useLocation();

  // ✅ override date ONLY if coming from calendar
  useEffect(() => {
    if (location.state?.selectedDate) {
      setSelectedDate(dayjs(location.state.selectedDate));
    }
    setAnimate(true);
  }, [location.state]);

  const [leadGuestOpen, setLeadGuestOpen] = useState(false);

  const getStatusStyle = (status) => {
    switch (status) {
      case "available":
        return {
          border: "border-l-4 border-green-500",
          bg: "bg-green-50",
          iconBg: "bg-green-100",
          iconColor: "text-green-500",
          text: "text-green-600",
          rightIcon: true,
        };

      case "sold":
        return {
          border: "border-l-4 border-red-500",
          bg: "bg-red-50",
          iconBg: "bg-red-100",
          iconColor: "text-red-500",
          text: "text-red-600",
          rightIcon: false,
        };

      default:
        return {
          border: "border-l-4 border-yellow-500",
          bg: "bg-yellow-50",
          iconBg: "bg-yellow-100",
          iconColor: "text-yellow-500",
          text: "text-yellow-600",
          rightIcon: false,
        };
    }
  };

  const getInfoContent = (index) => {
    const pkg = packages[index];

    if (!pkg) {
      return null;
    }

    return (
      <div className="text-white min-w-[300px] max-w-[300px]">
        <div className="flex justify-between items-center mb-4">
          <h4 className="text-lg font-semibold">More Information</h4>

          <CloseOutlined
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setOpenPopover(null);
            }}
          />
        </div>

        <Collapse
          ghost
          expandIconPosition="end"
          items={[
            {
              key: "1",
              label: "Voucher Confirmation",
              children: (
                <p>{pkg.voucher_confirmation || "No information available."}</p>
              ),
            },
            {
              key: "2",
              label: "Timings & Duration",
              children: (
                <p>{pkg.duration || "No duration information available."}</p>
              ),
            },
            {
              key: "3",
              label: "Booking Policy",
              children: (
                <p>{pkg.booking_policy || "No booking policy available."}</p>
              ),
            },
            {
              key: "4",
              label: "Child Policy",
              children: (
                <p>{pkg.child_policy || "No child policy available."}</p>
              ),
            },
            {
              key: "5",
              label: "Inclusions",
              children: <p>{pkg.inclusions || "No inclusions available."}</p>,
            },
            {
              key: "6",
              label: "Exclusions",
              children: <p>{pkg.exclusions || "No exclusions available."}</p>,
            },
          ]}
        />
      </div>
    );
  };

  const getDescriptionBullets = (description) => {
    if (!Array.isArray(description)) return [];

    return description.flatMap((block) => {
      if (block.type !== "list") return [];

      return (block.children || [])
        .map((item) =>
          (item.children || []).map((child) => child.text || "").join(""),
        )
        .filter(Boolean);
    });
  };

  const [dateSelecting, setDateSelecting] = useState(false);

  const handleDateSelect = (date) => {
    setDateSelecting(false);

    setSelectedDate(date);

    // Re-trigger animation even if another date was selected before
    requestAnimationFrame(() => {
      setDateSelecting(true);

      setTimeout(() => {
        setDateSelecting(false);
      }, 700);
    });
  };

  useEffect(() => {
    if (!selectedRef.current) return;

    selectedRef.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }, [selectedDate]);

  useEffect(() => {
    if (!open) return;

    const timer = setTimeout(() => {
      if (stripRef.current && selectedRef.current) {
        const container = stripRef.current;
        const item = selectedRef.current;

        container.scrollLeft =
          item.offsetLeft - (container.clientWidth - item.clientWidth) / 2;
      }
    }, 200);

    return () => clearTimeout(timer);
  }, [selectedDate, open]);
  return (
    <>
      <Drawer
        placement="right"
        width="90%"
        open={open}
        onClose={onClose}
        closable={false}
        maskClosable
        title={
          <div className="flex items-center justify-between w-full">
            <div>
              <Title
                className="!font-medium !text-danger !text-2xl !mb-1"
                level={2}
              >
                <span className="text-primary"> Book </span> Now
              </Title>
              <Paragraph className="!mb-0">
                Please select flight and hotel category
              </Paragraph>
            </div>
            <CloseOutlined
              onClick={onClose}
              className="cursor-pointer text-lg hover:text-red-500"
            />
          </div>
        }
      >
        <div>
          {step === 1 && (
            <Card className="card-no-border card-no-padding">
              <div style={{ width: "100%", overflow: "hidden" }}>
                <div className="date-strip" ref={stripRef}>
                  {dates.map((d) => {
                    const date = dayjs(d.date);
                    const active = selectedDate.isSame(date, "day");

                    return (
                      <div
                        key={d.date}
                        ref={active ? selectedRef : null}
                        className={`date-item ${
                          active ? "date-item-active" : ""
                        } ${active && dateSelecting ? "date-item-selecting" : ""}`}
                        onClick={() => handleDateSelect(date)}
                      >
                        <div className="date-day">{date.format("ddd")}</div>

                        <div className="date-number">
                          {date.format("MMM")} {date.format("DD")}
                        </div>

                        <div className="date-price">
                          AED {(d.price / 1000).toFixed(1)}K
                        </div>
                      </div>
                    );
                  })}

                  <div
                    className="month-block"
                    onClick={() => setCalendarOpen(true)}
                  >
                    <CalendarOutlined className="more-date-icon" />
                    <span>More Date</span>
                  </div>
                </div>
              </div>

              <Modal
                title={null}
                open={calendarOpen}
                footer={null}
                width={650}
                centered
                onCancel={() => setCalendarOpen(false)}
              >
                <div className="flex items-center justify-between mb-5">
                  <Button
                    type="text"
                    icon={<LeftOutlined />}
                    onClick={goPrevMonth}
                  />

                  <h3 className="text-lg font-medium">
                    {calendarMonth.format("MMMM YYYY")}
                  </h3>

                  <Button
                    type="text"
                    icon={<RightOutlined />}
                    onClick={goNextMonth}
                  />
                </div>

                <Calendar
                  fullscreen={false}
                  value={calendarMonth}
                  headerRender={() => null}
                  cellRender={cellRender}
                  onPanelChange={(date) => setCalendarMonth(date)}
                  onSelect={(date) => {
                    handleDateSelect(date);
                    setCalendarMonth(date.startOf("month"));
                    setCalendarOpen(false);
                  }}
                />
              </Modal>
              <Row gutter={24} className="">
                {/* LEFT */}
                <Col md={18}>
                  <Card className="card-no-border card-no-padding guest-card">
                    <Title
                      level={2}
                      className="!font-normal guest-title !text-primary !text-2xl !mb-2"
                    >
                      Number of Guests
                    </Title>
                    <Divider />
                    <div className="guest-adding-box divide-gray-300 flex guest-adding-box mb-[30px]">
                      {/* ADULT */}
                      <div className="guest-row  flex flex-col guest-box-col">
                        <span>
                          <span className="guest-label block">Adult</span>
                          <span className="list-style">(11 to 99 yrs)</span>
                        </span>
                        <div className="guest-counter">
                          <button onClick={() => setAdult(adult - 1)}>-</button>
                          <input value={adult} readOnly />
                          <button onClick={() => setAdult(adult + 1)}>+</button>
                        </div>
                      </div>
                      <div className="guest-box-col border-0 m-auto">
                        <div class="w-px h-0 md:h-24 bg-gray-300 max-w-[1px] m-auto"></div>
                      </div>

                      {/* CHILD */}

                      <div className="flex flex-col guest-box-col">
                        <div className="guest-row">
                          <span>
                            <span className="guest-label block">Child</span>
                            <span className="list-style">(3 to 11 years)</span>
                          </span>
                          <div className="guest-counter">
                            <button onClick={() => setChild(child - 1)}>
                              -
                            </button>
                            <input value={child} readOnly />
                            <button onClick={() => setChild(child + 1)}>
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="guest-box-col border-0 m-auto">
                        <div class="w-px h-0 md:h-24 bg-gray-300 max-w-[1px] m-auto"></div>
                      </div>
                      {/* INFANT */}
                      <div className="flex flex-col guest-box-col">
                        <div className="guest-row">
                          <span>
                            <span className="guest-label block">infant</span>
                            <span className="list-style">(0 to 3 yrs)</span>
                          </span>
                          <div className="guest-counter">
                            <button onClick={() => setInfant(infant - 1)}>
                              -
                            </button>
                            <input value={infant} readOnly />
                            <button onClick={() => setInfant(infant + 1)}>
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Divider className="mb-2" />
                  </Card>
                  <div className="package-slider">
                    {packagesLoading && (
                      <div className="py-8 text-center text-gray-500">
                        Loading packages...
                      </div>
                    )}

                    {!packagesLoading && packagesError && (
                      <div className="py-8 text-center text-red-500">
                        {packagesError}
                      </div>
                    )}

                    {!packagesLoading &&
                      !packagesError &&
                      packages.length === 0 && (
                        <div className="py-8 text-center text-gray-500">
                          No packages available.
                        </div>
                      )}

                    {!packagesLoading &&
                      !packagesError &&
                      packages.length > 0 && (
                        <Slider {...settings}>
                          {packages.map((pkg, index) => {
                            const descriptionBullets = getDescriptionBullets(
                              pkg.description,
                            );
                            const features = [
                              ...descriptionBullets,
                              pkg.availability,
                              pkg.meeting_point,
                            ].filter(Boolean);

                            return (
                              <div
                                className="px-2 py-3"
                                key={pkg.id || pkg.documentId || index}
                              >
                                <Card
                                  hoverable
                                  className="selectOptionsCard py-5"
                                >
                                  <div className="flex justify-between items-center gap-2 mb-4">
                                    <h4>{pkg.package_name}</h4>

                                    <Popover
                                      trigger="click"
                                      placement="leftTop"
                                      open={openPopover === index}
                                      onOpenChange={(visible) => {
                                        setOpenPopover(visible ? index : null);
                                      }}
                                      content={getInfoContent(index)}
                                      overlayClassName="packageInfoPopup"
                                    >
                                      <InfoCircleOutlined className="cursor-pointer" />
                                    </Popover>
                                  </div>

                                  <List
                                    bordered={false}
                                    dataSource={features}
                                    renderItem={(item) => (
                                      <List.Item
                                        className="list-style"
                                        style={{
                                          color: "#4D4D4D",
                                          border: "none",
                                          padding: 0,
                                        }}
                                      >
                                        <span className="flex items-start gap-3">
                                          <span className="font-bold text-[18px] text-[#4D4D4D]">
                                            •
                                          </span>

                                          <span>{item}</span>
                                        </span>
                                      </List.Item>
                                    )}
                                  />

                                  <div className="flex flex-col mb-5 mt-5">
                                    {pkg.old_price && (
                                      <span className="line-through font-normal leading-none text-sm text-[#4D4D4D]">
                                        AED {pkg.old_price}
                                      </span>
                                    )}

                                    <div className="flex items-center">
                                      <span className="text-[#000] !font-[16px]">
                                        AED {pkg.price}
                                      </span>

                                      {pkg.discount !== null &&
                                        pkg.discount !== undefined &&
                                        pkg.discount !== "" && (
                                          <Tag
                                            color="#28AC5D"
                                            className="ml-3 py-1 px-3"
                                          >
                                            {String(pkg.discount).includes("%")
                                              ? pkg.discount
                                              : `${pkg.discount}% off`}
                                          </Tag>
                                        )}
                                    </div>
                                  </div>

                                  <Button
                                    block
                                    type="danger"
                                    size="middle"
                                    onClick={() => {
                                      setSelectedPackage(index);
                                      setOpen(true);
                                    }}
                                    className="w-full mt-auto px-12 py-4 text-sm rounded-full bg-danger text-white"
                                  >
                                    Select Package
                                  </Button>
                                </Card>
                              </div>
                            );
                          })}
                        </Slider>
                      )}
                  </div>
                  <div>
                    <Title
                      level={2}
                      className="!font-normal guest-title !text-primary !text-2xl !mb-0 mt-8"
                    >
                      Select Time Options
                    </Title>
                    <Divider className="!mt-2" />
                    {/* Legend */}

                    <div className="flex flex-wrap gap-8 mb-8">
                      <div className="flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-green-500 ring-4 ring-green-100"></span>
                        <Text>Available</Text>
                      </div>

                      <div className="flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-red-400 ring-4 ring-red-100"></span>
                        <Text>Sold out</Text>
                      </div>

                      <div className="flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-yellow-400 ring-4 ring-yellow-100"></span>
                        <Text>Limited Availability</Text>
                      </div>
                    </div>

                    <Row gutter={[20, 20]}>
                      {visibleSlots.map((slot, index) => {
                        const style = getStatusStyle(slot.status);

                        return (
                          <Col xs={24} sm={12} md={8} lg={6} key={index}>
                            <Card
                              hoverable
                              onClick={() =>
                                slot.status !== "sold" &&
                                setSelectedTime(slot.time)
                              }
                              className={`
            cursor-pointer transition-all duration-200
            ${style.border}
            ${style.bg}
            ${selectedTime === slot.time ? "ring-2 ring-green-500" : ""}
          `}
                            >
                              <div className="flex justify-between px-4 pt-4">
                                <div
                                  className={`w-10 h-10 rounded-full ${style.iconBg} flex items-center justify-center`}
                                >
                                  <ClockCircleOutlined
                                    className={`text-xl ${style.iconColor}`}
                                  />
                                </div>

                                {selectedTime === slot.time && (
                                  <CheckCircleFilled className="text-green-500 text-3xl" />
                                )}
                              </div>

                              <h4
                                className={`text-base px-4 font-semibold mt-2 mb-2 ${style.text}`}
                              >
                                {slot.time}
                              </h4>

                              <Divider className="!my-2" />

                              <div className="space-y-2 px-4 pb-4">
                                <div className="flex items-center gap-2">
                                  <UserOutlined className={style.iconColor} />
                                  <span className="text-gray-600 text-xs">
                                    Adult: AED 65.00
                                  </span>
                                </div>

                                <div className="flex items-center gap-2">
                                  <UserOutlined className={style.iconColor} />
                                  <span className="text-gray-600 text-xs">
                                    Child: AED 65.00
                                  </span>
                                </div>
                              </div>
                            </Card>
                          </Col>
                        );
                      })}
                      ;
                    </Row>
                    {timeSlots.length > 8 && (
                      <div className="flex justify-center mb-6">
                        <Button onClick={() => setShowAllSlots(!showAllSlots)}>
                          {showAllSlots ? "Show Less" : "See More"}
                        </Button>
                      </div>
                    )}
                  </div>

                  <div>
                    <h3 className="text-[#1F3B8F] text-xl font-medium mb-5">
                      Select Transfer Option
                    </h3>

                    <Row gutter={[16, 16]}>
                      {transferOptions.map((item) => {
                        const selected = selectedTransfer === item.title;

                        return (
                          <Col xs={24} md={8} key={item.title}>
                            <Card
                              hoverable
                              onClick={() => setSelectedTransfer(item.title)}
                              className={`rounded-xl transition-all cursor-pointer ${
                                selected
                                  ? "border-2 border-green-400 shadow-sm"
                                  : "border border-gray-200 bg-[#F7F7F7]"
                              }`}
                              bodyStyle={{ padding: "18px" }}
                            >
                              <div className="flex items-center justify-between px-2 py-4">
                                {/* Left */}
                                <div className="flex items-center gap-4 flex-1">
                                  <div
                                    className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 ${
                                      selected
                                        ? "bg-green-500 text-white"
                                        : "bg-gray-200 text-[#1E3A8A]"
                                    }`}
                                  >
                                    <CheckOutlined />
                                  </div>

                                  <div>
                                    <h5 className="text-sm normal font-semibold text-[#333] mb-1">
                                      {item.title}
                                    </h5>

                                    <p className="text-xs font-medium text-[#666] leading-5 max-w-[240px]">
                                      {item.description}
                                    </p>
                                  </div>
                                </div>

                                {/* Price */}
                                <div className="text-right ml-6 flex-shrink-0">
                                  <div className="text-[#1E3A8A] text-sm font-bold">
                                    + AED
                                  </div>

                                  <div className="text-[#1E3A8A] text-sm font-bold">
                                    {item.price.toLocaleString()}
                                  </div>
                                </div>
                              </div>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>

                    <div className="border-t mt-8 pt-5 flex flex-col md:flex-row justify-between items-center">
                      <span className="text-gray-600">
                        Enter anytime within operating hours
                      </span>

                      <Button
                        block
                        type="danger"
                        size="middle"
                        onClick={() => setStep(2)}
                        className="!w-auto mt-4 px-12 py-5 text-sm rounded-md bg-danger text-white"
                      >
                        Next
                      </Button>
                    </div>
                  </div>
                </Col>

                {/* RIGHT */}
                <Col md={6}>
                  <Card className="mt-6 rounded-xl border p-[24px] border-[#E5E5E5] shadow-[0px_0px_4px_1px_rgba(0,0,0,0.1)]">
                    <h3 className="!text-base font-medium text-[#0A2381]">
                      Dubai Aquarium & Underwater Zoo with Penguin Cove Tickets
                    </h3>
                    <p className="text-[13px] text-[#C10707] mb-2 font-normal">
                      Silver Pass with Penguin Cove - Private Transfer
                    </p>
                    <hr className="mt-4 mb-4" />
                    <Flex justify="space-between" className="">
                      <div className="flex flex-col">
                        <div className="text-[13px] text-[#8C95A7] font-medium">
                          Dept. date:
                        </div>
                        <div className="text-sm font-medium">
                          {selectedDate.format("DD MMM YYYY")}
                        </div>
                      </div>

                      <div className="flex flex-col">
                        <div className="text-[13px] text-[#8C95A7] font-medium">
                          Time Slot
                        </div>
                        <div className="text-sm font-medium">
                          {selectedDate.format("hh:mm A")}
                        </div>
                      </div>
                    </Flex>
                    {/* Travelers: */}
                    <div className="text-[13px] text-[#8C95A7] mb-2 mt-5 font-medium">
                      Travelers:
                    </div>
                    <div className="flex justify-between mb-2">
                      <div className="text-sm font-medium">Adult: {adult}</div>
                      <div className="text-sm font-medium">AED 74872</div>
                    </div>

                    <div className="flex justify-between mb-2">
                      <div className="text-sm font-medium">Child: {child}</div>
                      <div className="text-sm font-medium">AED 0</div>
                    </div>

                    <div className="flex justify-between">
                      <div className="text-sm font-medium">
                        Infant: {infant}
                      </div>
                      <div className="text-sm font-medium">AED 0</div>
                    </div>
                    {/* Transfer (Meet at:) */}
                    <div className="text-[13px] text-[#8C95A7] mt-5 font-medium">
                      Transfer (Meet at:)
                    </div>
                    <p className="text-[13px] font-medium">
                      Dubai Aquarium & Underwater Zoo, The Dubai Mall, Lower
                      Ground Level, Downtown Dubai, Dubai
                    </p>

                    <Divider />
                    <div className="flex justify-between mb-2">
                      <div>
                        <h3 className="!text-sm font-medium">Basic Price</h3>
                      </div>
                      <div>
                        <h3 className="!text-sm font-medium text-right">
                          AED{" "}
                          {selectedPackage !== null
                            ? packages[selectedPackage]?.price || 0
                            : 0}
                        </h3>
                      </div>
                    </div>

                    <div className="flex justify-between my-4">
                      <p className="!text-xs text-[#189527] font-semibold font-normal">
                        Efficient Discount
                      </p>

                      <p className="!text-xs text-[#189527] font-semibold font-normal">
                        AED 0,744
                      </p>
                    </div>

                    <div className="flex justify-between mb-4">
                      <div>
                        <h3 className="!text-base font-medium">Total Amount</h3>
                        <p className="!text-xs text-[#8C95A7] font-normal">
                          View Pricing Table
                        </p>
                      </div>
                      <div>
                        <h3 className="!text-base text-right">
                          AED{" "}
                          {selectedPackage !== null
                            ? packages[selectedPackage]?.price || 0
                            : 0}
                        </h3>
                        <p className="!text-xs">*Excludes taxes</p>
                      </div>
                    </div>

                    <Button
                      block
                      type="danger"
                      size="middle"
                      onClick={() => setStep(2)}
                      className="w-full mt-4 px-12 py-5 text-sm rounded-md bg-danger text-white"
                    >
                      Next
                    </Button>
                  </Card>
                </Col>
              </Row>
            </Card>
          )}

          {step === 2 && (
            <LeadGuestDetails
              selectedDate={selectedDate}
              adult={adult}
              child={child}
              price={
                selectedPackage !== null
                  ? packages[selectedPackage]?.price || 0
                  : 0
              }
              onBack={() => setStep(1)}
              onClose={() => setLeadGuestOpen(false)}
            />
          )}
        </div>

        <Drawer
          placement="right"
          width={520}
          open={leadGuestOpen}
          onClose={() => setLeadGuestOpen(false)}
          destroyOnClose
          title={
            <div className="flex justify-between items-center">
              <span className="text-lg font-medium">Lead Guest Details</span>
              <CloseOutlined
                onClick={() => setLeadGuestOpen(false)}
                className="cursor-pointer"
              />
            </div>
          }
        ></Drawer>
      </Drawer>

      <Modal
        open={openModal}
        onCancel={() => setOpen(false)}
        footer={null}
        title="Choose Package (Required)"
        width={900}
      >
        <div className="grid grid-cols-3 gap-4">
          {addons.map((pkg, index) => (
            <div
              key={index}
              onClick={() => setSelectedAddon(index)}
              className={`flex flex-col gap-3 border rounded-xl p-3 cursor-pointer transition
        ${selectedAddon === index ? "border-blue-600 ring-2 ring-blue-300" : "border-gray-300"}`}
            >
              {/* Radio */}
              <div>
                <input
                  type="radio"
                  className="hidden"
                  checked={selectedAddon === index}
                  readOnly
                />
              </div>

              {/* Image */}
              <img
                src={pkg.image}
                className="w-full h-20 rounded-lg object-cover"
              />

              {/* Content */}
              <div className="flex-1">
                <p className="font-normal text-gray-600">{pkg.title}</p>
                <div className="flex justify-between mt-2 text-sm">
                  <span className="font-normal text-gray-600">Adult</span>
                  <span>AED {pkg.adultPrice}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="font-normal text-gray-600">Child</span>
                  <span>AED {pkg.childPrice}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div class="flex justify-end">
          <Button
            block
            type="danger"
            size="middle"
            onClick={() => {
              setOpen(false); // close modal
              setStep(2); // go to step 2
            }}
            className="w-full mt-4 px-12 py-5 text-sm rounded-md bg-danger text-white"
          >
            Next
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default BookingPage;
